import ImagesFabMainModal from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/ImagesFabMainModal';
import EditCulpritPropertyInsurance from '@/modules/adjusterReportModules/IncidentParticipants/components/propertyInsurance/editPropertyInsurance/forms/editCulpritPropertyInsurance/EditCulpritPropertyInsurance';
import EditDamagedPropertyInsurance from '@/modules/adjusterReportModules/IncidentParticipants/components/propertyInsurance/editPropertyInsurance/forms/editDamagedPropertyInsurance/EditDamagedPropertyInsurance';
import { PropertyInsuranceEnum } from '@/modules/adjusterReportModules/IncidentParticipants/types/PropertyInsurance.type';

const InsuranceInformationWrapper = ({
  type,
}: {
  type: PropertyInsuranceEnum;
}) => {
  return type === PropertyInsuranceEnum.culprit ? (
    <>
      <EditCulpritPropertyInsurance />
      <ImagesFabMainModal state={'propertyCulprit'} />
    </>
  ) : (
    <>
      <EditDamagedPropertyInsurance />
      <ImagesFabMainModal state={'propertyDamaged'} />
    </>
  );
};

export default InsuranceInformationWrapper;
